import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: 'EPL_00001',
                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'backoffice.titles',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'EPL_00050',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
            layerswitcher: {
                acl: {
                    view: 'EPL_00046',
                },
            },
            streetview: {
                acl: {
                    view: 'EPL_00048',
                },
            },
            expandcollapse: {
                active: true,
            },
            annotations: {
                acl: {
                    view: 'EPL_00069',
                },
            },
            layers: {
                active: true,
                title: 'layers.titles',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'EPL_00045',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
                selected: null,
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'EPL_00047',
                },
            },
            regulations: {
                active: true,
                title: 'regulations.titles',
                label: 'regulations.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'EPL_00063',
                },
                url: {
                    getData: `${codeAPI}/front/regulations`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            catalog: {
                acl: {
                    view: 'EPL_00054',
                },
            },
            identify: {
                acl: {
                    view: 'EPL_00055',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'EPL_00049',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            planemission: {
                model: 'plans',
                active: true,
                title: 'planemission.titles',
                label: 'planemission.label',
                panel: {
                    show: false,
                    loaded: false,
                    set_current_user: false,
                    draw: {
                        status: 0,
                    },
                    featureable: {
                        status: 0,
                    },
                    upload: {
                        status: 0,
                        minfeatures: 0,
                        maxfeatures: 5,
                        filterBoundary: '',
                        filterProperty: [],
                    },
                    notifications: {
                        status: 0,
                        channel: 'mail',
                    }
                },
                acl: {
                    view: 'EPL_00037',
                    featureable: 'EPL_00070',
                },
                url: {
                    create: `${codeAPI}/front/print/plan`,
                    status: `${codeAPI}/front/print/plan/job/:id`,
                    plans: `${codeAPI}/front/print/plan/front`,
                    formats: `${codeAPI}/front/uploadgeofile/formats`,
                    togeojson: `${codeAPI}/front/uploadgeofile/togeojson`,
                    featureable: `${codeAPI}/front/print/plan/featureable/:x/:y/:crs/:resolution`,
                }
            },
            pmdfciemission: {
                model: 'pmd_fcis',
                active: true,
                title: 'pmdfciemission.titles',
                label: 'pmdfciemission.label',
                panel: {
                    show: false,
                    loaded: false,
                    set_current_user: false,
                    draw: {
                        status: 0,
                    },
                    featureable: {
                        status: 0,
                    },
                    upload: {
                        status: 0,
                        minfeatures: 2,
                        maxfeatures: 2,
                        filterBoundaryTitle: 'pmdfciemission.upload.filterBoundaryTitle',
                        filterBoundary: '',
                        filterClaimTitle: 'pmdfciemission.upload.filterClaimTitle',
                        filterClaim: '',
                        filterProperty: [],
                    },
                    notifications: {
                        status: 0,
                        channel: 'mail',
                    }
                },
                acl: {
                    view: 'EPL_00038',
                    featureable: 'EPL_00073',
                },
                url: {
                    create: `${codeAPI}/front/print/pmdfci`,
                    status: `${codeAPI}/front/print/pmdfci/job/:id`,
                    formats: `${codeAPI}/front/uploadgeofile/formats`,
                    togeojson: `${codeAPI}/front/uploadgeofile/togeojson`,
                    featureable: `${codeAPI}/front/print/pmdfci/featureable/:x/:y/:crs/:resolution`,
                }
            },
            administrativeprocessemission: {
                model: 'work_types',
                active: true,
                title: 'administrativeprocessemission.titles',
                label: 'administrativeprocessemission.label',
                panel: {
                    show: false,
                    loaded: false,
                    set_current_user: false,
                    draw: {
                        status: 0,
                    },
                    featureable: {
                        status: 0,
                    },
                    upload: {
                        status: 0,
                        minfeatures: 1,
                        maxfeatures: 1,
                        filterBoundary: '',
                        filterProperty: [],
                    },
                    notifications: {
                        status: 0,
                        channel: 'mail',
                    }
                },
                acl: {
                    view: 'EPL_00036',
                    featureable: 'EPL_00071',
                },
                url: {
                    create: `${codeAPI}/front/print/administrativeprocess`,
                    status: `${codeAPI}/front/print/administrativeprocess/job/:id`,
                    workTypes: `${codeAPI}/front/print/administrativeprocess/front`,
                    formats: `${codeAPI}/front/uploadgeofile/formats`,
                    togeojson: `${codeAPI}/front/uploadgeofile/togeojson`,
                    featureable: `${codeAPI}/front/print/administrativeprocess/featureable/:x/:y/:crs/:resolution`,
                }
            },
            pisemission: {
                model: 'pis',
                active: true,
                title: 'pisemission.titles',
                label: 'pisemission.label',
                panel: {
                    show: false,
                    loaded: false,
                    set_current_user: false,
                    draw: {
                        status: 0,
                    },
                    featureable: {
                        status: 0,
                    },
                    upload: {
                        status: 0,
                        minfeatures: 1,
                        maxfeatures: 1,
                        filterBoundary: '',
                        filterProperty: [],
                    },
                    notifications: {
                        status: 0,
                        channel: 'mail',
                    }
                },
                acl: {
                    view: 'EPL_00039',
                    featureable: 'EPL_00072',
                },
                url: {
                    create: `${codeAPI}/front/print/pis`,
                    status: `${codeAPI}/front/print/pis/job/:id`,
                    formats: `${codeAPI}/front/uploadgeofile/formats`,
                    togeojson: `${codeAPI}/front/uploadgeofile/togeojson`,
                    featureable: `${codeAPI}/front/print/pis/featureable/:x/:y/:crs/:resolution`,
                }
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
            }
        },
        config: {

        },
    },
};

export default state;